<template>
    <transition type="animation" appear enter-active-class="animate__animated animate__fadeIn" mode="out-in">
        <div class="carreiras">
            <div id="header">
                <div class="img__header">
                    <div class="bg__escuro"></div>
                    <div class="bg__title">
                        <h2 class="text-title">Carreiras</h2>
                    </div>
                </div>
            </div>
            <BreadSistema />

            <div class="main">
                <div class="main__carreiras">
                    <div class="sidebar__vagas d-none d-md-block">
                        <b-card no-body class="pt-3 pr-2 pb-3 pl-2">
                            <h5>Filtrar:</h5>
                            <hr class="mt-1 mb-3">
                            <b-form-checkbox>
                                Desenvolvimento
                            </b-form-checkbox>
                            <b-form-checkbox>
                                Administração
                            </b-form-checkbox>
                            <b-form-checkbox>
                                Professor
                            </b-form-checkbox>
                            <b-form-checkbox>
                                Secretária
                            </b-form-checkbox>
                            <b-form-checkbox>
                                Gráfica
                            </b-form-checkbox>
                            <b-form-checkbox>
                                ...
                            </b-form-checkbox>
                        </b-card>
                    </div>
                    <div class="content__vagas">
                        <b-card no-body class="pt-3 pr-2 pb-3 pl-2">
                            Conteúdo de vagas
                        </b-card>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default {
    name: 'page-de-carreiras',
    components: { BreadSistema: () => import('../GlobalComponents/bread-sistema.vue') }
}
</script>
<style scoped>
.carreiras {
    background-color: #f6f6f6;
}

#header {
    width: 100%;
    height: 500px;
}

.img__header {
    position: absolute;
    display: block;
    background-image: url('https://app-sistemacpv.s3.amazonaws.com/images/carreiras.jpg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top center;
    width: 100%;
    height: 500px;
    object-fit: cover;
}

.bg__escuro {
    background-color: #00000074;
    background-size: 100% auto !important;
    width: 100%;
    height: 500px;
}

.bg__title {
    position: relative;
    width: 100%;
    min-height: 50px;
    max-height: 115px;
    padding: 35px 7%;
    top: -23%;
    bottom: 0%;

    display: flex;
    align-items: center;
    justify-content: end !important;

    background-color: #e98a2498;
}

h2.text-title {
    color: #fdf3e9;

    font-size: 40px;
    font-weight: 600;

    line-height: 52px;

    text-shadow: 0 0 8px 8px #fdf3e9;
    text-align: end;

    display: flex;
    align-items: center;
    justify-content: end;
}

.main {
    width: 75%;
    height: auto;

    display: block;
    margin: 0 auto;
    border: 2px solid red;
}

.main__carreiras {
    display: grid;
    grid-template-columns: 25% 2fr;
    grid-template-rows: auto;
    gap: 4px;
    padding: 10px 0;
}

.sidebar__vagas {
    display: flex;
    justify-content: start;
    align-items: center;
}

.content__vagas {
    width: 100%;
}

.sidebar__vagas hr {

    border-color: #e5e5e5;
}
</style>